import React, { createContext, useContext, useEffect, useState } from 'react';
import { setConfig as setGlobalConfig } from './stores/configStore';

// eslint-disable-next-line func-call-spacing
const ConfigContext = createContext<{
    config: Record<string, any>;
    // eslint-disable-next-line func-call-spacing
    setConfig: (config: Record<string, any>) => void;
}>({ config: {}, setConfig: () => {} });

export const useConfig = () => useContext(ConfigContext);

export const ConfigProvider = ({ children }: { children: React.ReactNode }) => {
    const [config, setConfig] = useState<Record<string, any>>({});

    const onHandleSetConfig = (config: Record<string, any>) => {
        setConfig(prev => ({ ...prev, ...config }));
        setGlobalConfig(config);
    };

    const init = () => {
        onHandleSetConfig({
            APP_TYPE: process.env.REACT_APP_TYPE,
            API_PUBLIC_KEY: process.env.REACT_APP_API_PUBLIC_KEY,
            API_HOST: process.env.REACT_APP_API_HOST,
            API_APP_ID: process.env.REACT_APP_API_APP_ID,
            API_TIME_OUT: process.env.REACT_APP_API_TIMEOUT,
            MAX_FILE_SIZE: process.env.REACT_APP_MAX_FILE_SIZE,
            CO_BROWSE_LISCENSE_KEY: process.env.REACT_APP_CO_BROWSE_LISCENSE_KEY,
            FIRESTORE_DB_ENV_VERSION: process.env.REACT_APP_FIRESTORE_DB_ENV_VERSION,
            FIRESTORE_DB_ENV_VERSION_NAME: process.env.REACT_APP_FIRESTORE_DB_ENV_VERSION_NAME,
            APP_ENV: process.env.REACT_APP_ENV,
            OS_TYPE: 'web-welfare',
            MAX_VOICE_RECORDING: process.env.REACT_APP_MAX_VOICE_RECORDING,
            LANGUAGE: process.env.REACT_APP_LANGUAGE,
            WELFARE_ACCESS: process.env.REACT_APP_ADMIN_ACCESS?.split('|'),
            MAPBOX_API: process.env.REACT_APP_MAPBOX_API,
            MAPBOX_KEY: process.env.REACT_APP_MAPBOX_KEY,
            ASSEMBLYAI_API: process.env.REACT_APP_ASSEMBLYAI_API,
            ASSEMBLYAI_API_KEY: process.env.REACT_APP_ASSEMBLYAI_API_KEY,
            FINANCIAL_SUPPORT_ID: process.env.REACT_APP_FINANCIAL_SUPPORT_ID,
            CURRENTLY_SERVING_GROUP_QUESTION:
                process.env.REACT_APP_CURRENTLY_SERVING_GROUP_QUESTION,
            PRIORITY_GROUPS: process.env.REACT_APP_PRIORITY_GROUPS,
            PRIORITY_GROUP_ORDER: process.env.REACT_APP_PRIORITY_GROUP_ORDER,
            LOOKING_FOR_ASSISTANCE_ID: process.env.REACT_APP_LOOKING_FOR_FINANCIAL_ID,
            MEMBER_PUBLIC_STATUS: process.env.REACT_APP_MEMBER_PUBLIC_STATUS,
            SPACE_ENDPOINT_URL: process.env.REACT_APP_SPACE_ENDPOINT_URL,
            SPACE_REGION: process.env.REACT_APP_SPACE_REGION,
            SPACE_ACCESS_KEY: process.env.REACT_APP_SPACE_ACCESS_KEY,
            SPACE_SECRET_KEY: process.env.REACT_APP_SPACE_SECRET_KEY,
            SPACE_ENDPOINT_CDN_URL: process.env.REACT_APP_SPACE_ENDPOINT_CDN_URL,
            SPACE_NAME: process.env.REACT_APP_SPACE_NAME,
            SPACE_PRESIGNED_URL_EXPIRY_HOURS:
                process.env.REACT_APP_SPACE_PRESIGNED_URL_EXPIRY_HOURS,
        });
    };

    useEffect(() => {
        init();
    }, []);

    return (
        <ConfigContext.Provider value={{ config, setConfig: onHandleSetConfig }}>
            {children}
        </ConfigContext.Provider>
    );
};
